import './Auth.css';

export default function MaintenancePage() {
  return (
    <div className="auth-page">
      <div className="auth-branding">
        <div className="auth-branding-inner">
          <div className="auth-logo"><img src="/wf-logo.png" alt="Wow Factor Baseball" style={{width:'192px',height:'192px',objectFit:'contain'}} /></div>
          <h1 className="auth-brand-name">WOW FACTOR</h1>
          <p className="auth-brand-sub">Baseball Training & Development</p>
          <div className="auth-brand-divider" />
          <p className="auth-brand-quote">Built different.<br />Train with purpose.</p>
        </div>
      </div>
      <div className="auth-form-panel">
        <div className="auth-form-container" style={{ textAlign:'center' }}>
          <div style={{ fontSize:'3.5rem', marginBottom:'20px' }}>🔧</div>
          <h2 style={{ fontFamily:'var(--font-display)', fontSize:'2rem', letterSpacing:'0.05em', marginBottom:'16px' }}>SCHEDULED MAINTENANCE</h2>
          <p style={{ color:'var(--text-primary)', fontWeight:'600', fontSize:'1rem', lineHeight:'1.7', marginBottom:'12px' }}>
            Wow Factor Baseball is temporarily unavailable.
          </p>
          <p style={{ color:'var(--text-secondary)', fontSize:'0.9rem', lineHeight:'1.8', marginBottom:'12px' }}>
            We are currently performing scheduled maintenance to improve the platform and your overall experience.
            Our team is working diligently to restore full access as quickly as possible.
          </p>
          <p style={{ color:'var(--text-secondary)', fontSize:'0.9rem', lineHeight:'1.8', marginBottom:'28px' }}>
            We sincerely apologize for any inconvenience and appreciate your patience and understanding during this time.
          </p>
          <div style={{ background:'var(--bg-elevated)', border:'1px solid var(--border)', borderRadius:'var(--radius-lg)', padding:'20px 24px', marginBottom:'28px', textAlign:'left' }}>
            <p style={{ color:'var(--text-primary)', fontWeight:'600', fontSize:'0.875rem', margin:'0 0 10px' }}>While you wait:</p>
            <p style={{ color:'var(--text-muted)', fontSize:'0.85rem', margin:'0 0 6px' }}>• Maintenance windows are typically brief — please check back shortly</p>
            <p style={{ color:'var(--text-muted)', fontSize:'0.85rem', margin:'0 0 6px' }}>• Contact your instructor directly if you have an urgent session matter</p>
            <p style={{ color:'var(--text-muted)', fontSize:'0.85rem', margin:'0' }}>• Use the button below to refresh and check if the site is back online</p>
          </div>
          <button className="btn btn-primary" onClick={() => window.location.reload()} style={{ width:'100%', marginBottom:'12px' }}>
            Refresh &amp; Try Again
          </button>
          <p style={{ color:'var(--text-muted)', fontSize:'0.78rem', marginTop:'8px' }}>
            Thank you for being part of the Wow Factor Baseball community.
          </p>
        </div>
      </div>
    </div>
  );
}
